export enum CustomEvents {
  CheckinStatusesUpdated = 'checkinStatusesUpdated',
  CondoStartEndDateChanged = 'condoStartEndDateChanged',
  CheckinStatusesLoading = 'checkinStatusesLoading',
  LastCheckinEndDate = 'lastCheckinEndDate',
}
